import { createSlice } from '@reduxjs/toolkit';

export interface CompanyCompletedProjectInterface {
  id: string;
  projectName: string;
  dateCompleted: string;
  streetAddress: string;
  city: string;
  state: { label: string; value: string };
  zipCode: number | null;
  grossBuildingArea: number | null;
  housingUnits: number | null;
  developmentCost: number | null;
  projectTypes: string[];
  constructionTypes: string[];
  companyRole?: string[];
  partialOwner?: string;
}

export interface PrincipalCompletedProjectInterface {
  id: string;
  companyName: string;
  projectName: string;
  dateCompleted: string;
  streetAddress: string;
  city: string;
  state: { label: string; value: string };
  zipCode: number | null;
  grossBuildingArea: number | null;
  housingUnits: number | null;
  developmentCost: number | null;
  projectTypes: string[];
  constructionTypes: string[];
}

export interface ExperienceInterface {
  companyCompleted: CompanyCompletedProjectInterface[];
  principalCompleted: PrincipalCompletedProjectInterface[];
}

const initialState: ExperienceInterface = {
  companyCompleted: [],
  principalCompleted: [],
};

export const experienceSlice = createSlice({
  name: 'experience',
  initialState,
  reducers: {
    clearExperience: () => initialState,
    setExperience(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { setExperience, clearExperience } = experienceSlice.actions;
export default experienceSlice.reducer;
